export default __webpack_public_path__ + "static/media/questions-icon.bfaa440b.png";